/* PSI reels — replaces Storista (25 Oct 2026). v3: Instagram-Stories style player.
   Cards play a muted low-res preview only while on screen; the full video loads only when tapped.
   Player: tap right = next, tap left = back, hold = pause, swipe left/right = next/back, swipe down = close.
   Speed: adaptive HLS everywhere (native on iPhone, hls.js loaded lazily elsewhere, starting on a light rendition),
   the next reel is buffered in a second <video> while the current one plays, posters show instantly.
   Clarity events: psi_reel_open, psi_reel_shop, psi_reel_filter. */
(function () {
  if (window.__psiReels) return; window.__psiReels = true;
  var HLSJS = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.20/dist/hls.light.min.js';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  function track(name) { try { window.clarity && window.clarity('event', name); } catch (e) {} }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- streaming ---------- */
  var nativeHls = (function () { try { return !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl'); } catch (e) { return false; } })();
  var hlsLoading = null;
  function loadHls() {
    if (nativeHls) return Promise.resolve(null);
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsLoading) hlsLoading = new Promise(function (res) {
      var s = document.createElement('script'); s.src = HLSJS; s.async = true;
      s.onload = function () { res(window.Hls && window.Hls.isSupported() ? window.Hls : null); };
      s.onerror = function () { res(null); };
      document.head.appendChild(s);
    });
    return hlsLoading;
  }
  function warmHls() { if (nativeHls || hlsLoading) return; var go = function () { loadHls(); }; if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 1200 }); else setTimeout(go, 1200); } /* 26 Oct 2026: was passing a number to requestIdleCallback (TypeError on Chrome) */
  function detach(v) {
    if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; }
    v._key = null; v.removeAttribute('src'); try { v.load(); } catch (e) {}
  }
  /* attach(item) to a <video>; mode 'play' (big buffer, auto quality) | 'buffer' (next reel, small buffer) | 'preview' (card, lowest quality) */
  function attach(v, it, mode) {
    var hls = it.dataset.hls, mp4 = it.dataset.src, key = (hls || mp4) + '|' + mode;
    if (v._key === key) return;
    if (v._key && v._key.split('|')[0] === (hls || mp4)) { // same stream already attached: keep what is buffered
      if (v._hls) { v._hls.config.maxBufferLength = mode === 'play' ? 20 : 4; if (mode === 'play') v._hls.autoLevelCapping = -1; }
      v._key = key; return;
    }
    detach(v); v._key = key;
    if (hls && nativeHls) { v.src = hls; return; }
    if (hls && window.Hls) {
      var h = new window.Hls({
        startLevel: mode === 'play' ? -1 : 0, capLevelToPlayerSize: true, maxBufferLength: mode === 'play' ? 20 : 4,
        maxMaxBufferLength: 30, startFragPrefetch: true, testBandwidth: mode === 'play', abrEwmaDefaultEstimate: 1500000, enableWorker: true
      });
      if (mode === 'preview') h.autoLevelCapping = 0;
      h.on(window.Hls.Events.ERROR, function (_, d) { if (d && d.fatal) { try { h.destroy(); } catch (e) {} v._hls = null; if (mp4) { v.src = mp4; if (v._wantPlay) v.play().catch(function () {}); } } });
      h.loadSource(hls); h.attachMedia(v); v._hls = h; return;
    }
    v.src = mp4 || hls;
  }

  /* ---------- muted previews on cards ---------- */
  var live = new Set(), MAX_LIVE = 1;
  function startPreview(btn) {
    if (reduce || saveData) return;
    if (live.size >= MAX_LIVE) live.forEach(function (o) { if (o !== btn) stopPreview(o); });
    var v = btn.querySelector('video.psi-rl__live');
    if (!v) {
      v = document.createElement('video');
      v.className = 'psi-rl__live'; v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.volume = 0; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true'); v.preload = 'none';
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      var shade = btn.querySelector('.psi-rl__shade'); btn.insertBefore(v, shade);
    }
    loadHls().then(function () { if (!live.has(btn)) return; attach(v, btn, 'preview'); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    live.add(btn);
  }
  function stopPreview(btn) { var v = btn.querySelector('video.psi-rl__live'); if (v) { v.pause(); v.classList.remove('is-on'); } live.delete(btn); }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) startPreview(e.target); else stopPreview(e.target); });
  }, { threshold: [0, 0.6] }) : null;
  var warmIo = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { warmHls(); warmIo.disconnect(); } });
  }, { rootMargin: '600px 0px' }) : null;

  function initRail(sec) {
    if (sec.__psi) return; sec.__psi = true;
    var trackEl = sec.querySelector('[data-track]'), prev = sec.querySelector('[data-prev]'), next = sec.querySelector('[data-next]');
    function upd() { if (!trackEl) return; prev && (prev.disabled = trackEl.scrollLeft < 8); next && (next.disabled = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 8); }
    prev && prev.addEventListener('click', function () { trackEl.scrollBy({ left: -trackEl.clientWidth * 0.85, behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { trackEl.scrollBy({ left: trackEl.clientWidth * 0.85, behavior: 'smooth' }); });
    trackEl && trackEl.addEventListener('scroll', upd, { passive: true }); upd();
    sec.querySelectorAll('[data-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var k = chip.getAttribute('data-chip');
        sec.querySelectorAll('[data-chip]').forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        sec.querySelectorAll('.psi-rl__cell[data-theme]').forEach(function (cell) { cell.hidden = !!k && cell.getAttribute('data-theme') !== k; });
        live.forEach(stopPreview); if (trackEl) trackEl.scrollLeft = 0; upd();
        track('psi_reel_filter');
      });
    });
    if (io) sec.querySelectorAll('[data-reel]').forEach(function (b) { if (!b.classList.contains('psi-rl__item--pill') && !b.closest('[hidden]')) io.observe(b); });
    if (warmIo) warmIo.observe(sec);
  }
  function initBubble(b) {
    if (b.__psi) return; b.__psi = true;
    if (ss(b.dataset.key) === 'closed') return;
    b.hidden = false;
    var item = b.querySelector('[data-reel]'); if (item) setTimeout(function () { startPreview(item); }, 1200);
    if (warmIo) warmIo.observe(b);
    b.querySelector('[data-bubble-close]').addEventListener('click', function () { if (item) stopPreview(item); b.remove(); ss(b.dataset.key, 'closed'); });
  }

  /* ---------- Stories player ---------- */
  var GEN = 0;
  function isOpen() { return P && !P.hidden; }
  var P, stage, vids = [], cur = 0, group = [], idx = 0, opener = null, muted = ss('psi_rp_muted') === '1', paused = false, held = false;
  var ICON = {
    x: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    on: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/></svg>',
    off: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="30" height="30"><path d="M8 5.5v13l10.5-6.5z" fill="#fff"/></svg>'
  };
  function V() { return vids[cur]; }
  function build() {
    P = document.createElement('div'); P.className = 'psi-rp'; P.hidden = true;
    P.setAttribute('role', 'dialog'); P.setAttribute('aria-modal', 'true'); P.setAttribute('aria-label', 'Party videos');
    P.innerHTML = '<div class="psi-rp__stage">' +
      '<div class="psi-rp__media"><video class="psi-rp__video" playsinline webkit-playsinline preload="auto"></video><video class="psi-rp__video" playsinline webkit-playsinline preload="auto"></video></div>' +
      '<div class="psi-rp__veil"></div><div class="psi-rp__bars"></div>' +
      '<div class="psi-rp__top"><span class="psi-rp__av"><img alt="" /></span><span class="psi-rp__title"></span>' +
      '<button type="button" class="psi-rp__btn" data-mute aria-label="Sound"></button><button type="button" class="psi-rp__btn" data-close aria-label="Close videos">' + ICON.x + '</button></div>' +
      '<div class="psi-rp__gest" data-gest></div><div class="psi-rp__paused" aria-hidden="true">' + ICON.play + '</div><div class="psi-rp__spin" aria-hidden="true"></div>' +
      '<div class="psi-rp__hint" aria-hidden="true"><span>Tap to see the next party</span></div>' +
      '<div class="psi-rp__shop"></div></div>' +
      '<button type="button" class="psi-rp__nav psi-rp__nav--prev" data-prev aria-label="Previous video">' + ICON.prev + '</button>' +
      '<button type="button" class="psi-rp__nav psi-rp__nav--next" data-next aria-label="Next video">' + ICON.next + '</button>';
    document.body.appendChild(P);
    stage = P.querySelector('.psi-rp__stage');
    vids = Array.prototype.slice.call(P.querySelectorAll('video'));
    vids.forEach(function (v, k) {
      v.addEventListener('timeupdate', function () { if (k !== cur) return; var b = P.querySelectorAll('.psi-rp__bars b')[idx]; if (b && v.duration) b.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration) + ')'; });
      v.addEventListener('ended', function () { if (k !== cur) return; if (idx < group.length - 1) go(idx + 1, 1); else { v.currentTime = Math.max(0, v.duration - 3.2); v.pause(); setPaused(true); } });
      v.addEventListener('waiting', function () { if (k === cur) P.classList.add('is-loading'); });
      v.addEventListener('playing', function () { if (k === cur) P.classList.remove('is-loading'); });
      v.addEventListener('canplay', function () { if (k === cur) P.classList.remove('is-loading'); });
    });
    P.querySelector('[data-close]').addEventListener('click', function () { close(true); });
    P.querySelector('[data-mute]').addEventListener('click', function () { muted = !muted; vids.forEach(function (v) { v.muted = muted; }); ss('psi_rp_muted', muted ? '1' : '0'); muteIcon(); });
    P.querySelector('[data-prev]').addEventListener('click', function () { go(idx - 1, -1); });
    P.querySelector('[data-next]').addEventListener('click', function () { go(idx + 1, 1); });
    P.querySelector('.psi-rp__shop').addEventListener('click', function (e) { if (e.target.closest('a')) track('psi_reel_shop'); });
    P.addEventListener('click', function (e) { if (e.target === P) close(true); });
    gestures(P.querySelector('[data-gest]'));
    document.addEventListener('keydown', function (e) {
      if (P.hidden) return;
      if (e.key === 'Escape') close(true);
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, -1); }
      else if (e.key === ' ') { e.preventDefault(); setPaused(!paused); }
    });
    window.addEventListener('popstate', function () { if (!P.hidden) close(false); });
    var bgPaused = false;
    document.addEventListener('visibilitychange', function () {
      if (!P || P.hidden) return;
      if (document.hidden) { if (!paused) { bgPaused = true; setPaused(true); } }
      else if (bgPaused) { bgPaused = false; setPaused(false); }
    });
  }
  function gestures(g) {
    var x0, y0, t0, dx = 0, dy = 0, axis = null, holdT = null, active = false;
    function reset() { stage.style.transition = ''; stage.style.transform = ''; P.style.setProperty('--rp-fade', '1'); }
    g.addEventListener('pointerdown', function (e) {
      active = true; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); dx = dy = 0; axis = null; held = false;
      try { g.setPointerCapture(e.pointerId); } catch (err) {}
      clearTimeout(holdT); holdT = setTimeout(function () { if (!axis) { held = true; P.classList.add('is-holding'); V().pause(); } }, 220);
    });
    g.addEventListener('pointermove', function (e) {
      if (!active) return;
      dx = e.clientX - x0; dy = e.clientY - y0;
      if (!axis && Math.abs(dx) + Math.abs(dy) > 10) { axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; clearTimeout(holdT); if (held) { held = false; P.classList.remove('is-holding'); } }
      if (axis === 'x') { var edge = (dx > 0 && idx === 0) || (dx < 0 && idx === group.length - 1); stage.style.transition = 'none'; stage.style.transform = 'translateX(' + (edge ? dx * 0.3 : dx) + 'px)'; }
      else if (axis === 'y' && dy > 0) { stage.style.transition = 'none'; stage.style.transform = 'translateY(' + dy + 'px) scale(' + Math.max(0.86, 1 - dy / 1600) + ')'; P.style.setProperty('--rp-fade', String(Math.max(0.2, 1 - dy / 500))); }
    });
    function end(e) {
      if (!active) return; active = false; clearTimeout(holdT);
      var dt = Date.now() - t0, w = g.clientWidth || window.innerWidth;
      if (held) { held = false; P.classList.remove('is-holding'); if (!paused && isOpen()) V().play().catch(function () {}); reset(); return; }
      if (axis === 'x') {
        var fast = Math.abs(dx) / Math.max(dt, 1) > 0.5, far = Math.abs(dx) > w * 0.22;
        if ((fast || far) && ((dx < 0 && idx < group.length - 1) || (dx > 0 && idx > 0))) { slide(dx < 0 ? 1 : -1); return; }
        stage.style.transition = 'transform .22s ease'; stage.style.transform = ''; return;
      }
      if (axis === 'y') {
        if (dy > 110) { close(true); return; }
        stage.style.transition = 'transform .22s ease'; reset(); return;
      }
      if (e.type === 'pointercancel') return;
      var r = g.getBoundingClientRect(), rx = (x0 - r.left) / r.width;
      if (rx < 0.3) go(idx - 1, -1); else go(idx + 1, 1);
    }
    g.addEventListener('pointerup', end); g.addEventListener('pointercancel', end);
    g.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }
  function slide(dir) {
    var w = stage.clientWidth;
    stage.style.transition = 'transform .2s cubic-bezier(.3,.7,.4,1)'; stage.style.transform = 'translateX(' + (-dir * w) + 'px)';
    var g = GEN;
    setTimeout(function () {
      if (g !== GEN || !isOpen()) return;
      stage.style.transition = 'none'; stage.style.transform = 'translateX(' + (dir * w * 0.35) + 'px)';
      go(idx + dir, 0);
      requestAnimationFrame(function () { requestAnimationFrame(function () { stage.style.transition = 'transform .22s cubic-bezier(.3,.7,.4,1)'; stage.style.transform = ''; }); });
    }, 190);
  }
  function setPaused(p) { paused = p; P.classList.toggle('is-paused', p); if (p || !isOpen()) V().pause(); else V().play().catch(function () {}); }
  function muteIcon() { var b = P.querySelector('[data-mute]'); b.innerHTML = muted ? ICON.off : ICON.on; b.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute'); }
  function go(i, dir) {
    if (!isOpen()) return;
    if (i < 0 || i >= group.length) { if (dir) { stage.classList.remove('is-bump'); void stage.offsetWidth; stage.classList.add('is-bump'); } return; }
    var it = group[i], other = 1 - cur, ov = vids[other];
    var ready = ov._key && ov._key.indexOf(it.dataset.hls || it.dataset.src) === 0;
    var old = V(); old._wantPlay = false; old.pause();
    cur = other; // the other <video> either already buffers this reel or gets it now
    var v = V(); v._wantPlay = true;
    vids.forEach(function (x, k) { x.classList.toggle('is-on', k === cur); });
    idx = i; paused = false; P.classList.remove('is-paused', 'is-holding');
    v.poster = it.dataset.poster || ''; v.muted = muted;
    attach(v, it, 'play');
    if (ready && v.currentTime > 0.5) v.currentTime = 0;
    P.classList.toggle('is-loading', v.readyState < 3);
    var g = GEN, p = v.play(); if (p && p.catch) p.catch(function (err) { if (g !== GEN || !isOpen() || V() !== v || (err && err.name === 'AbortError')) return; muted = true; v.muted = true; muteIcon(); v.play().catch(function () {}); });
    P.querySelector('.psi-rp__title').textContent = it.dataset.title || '';
    var av = P.querySelector('.psi-rp__av img'); av.src = it.dataset.poster ? it.dataset.poster.replace(/width=\d+/, 'width=96') : '';
    var tpl = it.querySelector('template[data-shop]') || (it.dataset.shopKey && document.querySelector('template[data-shop-for="' + it.dataset.shopKey + '"]'));
    P.querySelector('.psi-rp__shop').innerHTML = tpl ? tpl.innerHTML.trim() : '';
    var bars = P.querySelector('.psi-rp__bars');
    bars.innerHTML = group.map(function (_, k) { return '<i class="' + (k < i ? 'is-done' : '') + '"><b></b></i>'; }).join('');
    P.querySelector('[data-prev]').disabled = i === 0; P.querySelector('[data-next]').disabled = i === group.length - 1;
    muteIcon();
    // buffer the next reel in the other <video>
    var nx = group[i + 1], bv = vids[1 - cur]; bv._wantPlay = false; bv.pause();
    if (nx) { bv.muted = true; bv.preload = 'auto'; bv.poster = nx.dataset.poster || ''; attach(bv, nx, 'buffer'); try { bv.currentTime = 0; } catch (e) {} }
    // warm the poster after next
    var n2 = group[i + 2]; if (n2 && n2.dataset.poster) { var im = new Image(); im.src = n2.dataset.poster; }
  }
  function open(btn) {
    if (!P) build();
    var scope = btn.closest('[data-psi-reels]') || btn.closest('[data-psi-bubble]') || document;
    group = Array.prototype.slice.call(scope.querySelectorAll('[data-reel]')).filter(function (b) { return !b.closest('.psi-rl__cell[hidden]'); });
    opener = btn; live.forEach(stopPreview);
    P.hidden = false; document.documentElement.style.overflow = 'hidden'; P.style.setProperty('--rp-fade', '1'); stage.style.transform = '';
    try { history.pushState({ psiReel: 1 }, ''); } catch (e) {}
    if (!ss('psi_rp_hint') && group.length > 1) { P.classList.add('show-hint'); ss('psi_rp_hint', '1'); setTimeout(function () { P.classList.remove('show-hint'); }, 2600); }
    GEN++; var g0 = GEN;
    var start = Math.max(0, group.indexOf(btn));
    var ready = nativeHls || window.Hls || !group[start].dataset.hls ? Promise.resolve() : Promise.race([loadHls(), new Promise(function (r) { setTimeout(r, 900); })]);
    // show poster immediately while the stream library arrives
    vids.forEach(function (v) { v.poster = btn.dataset.poster || ''; });
    P.classList.add('is-loading');
    ready.then(function () { if (g0 === GEN && isOpen()) go(start, 0); });
    P.querySelector('[data-close]').focus({ preventScroll: true });
    track('psi_reel_open');
  }
  function close(fromUi) {
    GEN++;
    clearTimeout(window.__psiHoldT);
    vids.forEach(function (v) { v._wantPlay = false; v.muted = true; v.pause(); detach(v); });
    document.querySelectorAll('video.psi-rl__live').forEach(function (v) { v.muted = true; });
    P.hidden = true; document.documentElement.style.overflow = ''; stage.style.transform = '';
    if (fromUi) { try { if (history.state && history.state.psiReel) history.back(); } catch (e) {} }
    if (opener) opener.focus({ preventScroll: true });
  }
  document.addEventListener('play', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO') return;
    if (v.classList.contains('psi-rl__live')) { if (!v.muted) v.muted = true; return; }
    if (P && P.contains(v) && (!isOpen() || V() !== v)) { v.muted = true; v.pause(); }
  }, true);
  window.addEventListener('pagehide', function () { if (isOpen()) close(false); document.querySelectorAll('video.psi-rl__live').forEach(function (v) { v.pause(); }); });
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-reel]'); if (b && (!P || !P.contains(b))) { e.preventDefault(); open(b); } });

  function boot() {
    document.querySelectorAll('[data-psi-reels]').forEach(initRail);
    document.querySelectorAll('[data-psi-bubble]').forEach(initBubble);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
